var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-module":"category-page-header"}},[_c('div',{staticClass:"color-block",style:(_vm.colorBlockStyles)}),_vm._v(" "),_c('div',{staticClass:"component-layout"},[_c('h1',[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_c('p',{ref:"burnerText"},[_vm._v(_vm._s(_vm.data.burner))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d4201e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/work/CategoryHeader.vue
// module id = 8Sbb
// module chunks = 1